import HeadlessModal from '@/components/shared/HeadlessModal';
import { useTranslations } from 'next-intl';
import React from 'react';

interface Props {
  openInfoModal: boolean;
  setOpenInfoModal: (open: boolean) => void;
  content: string;
}

export default function ImpressumModal({
  openInfoModal,
  setOpenInfoModal,
  content,
}: Props) {
  const t = useTranslations();
  return (
    <HeadlessModal
      isOpen={openInfoModal}
      closeModal={() => setOpenInfoModal(false)}
      dialogPanelClassName="!min-h-min !p-0"
      dialogBodyClass="overflow-y-auto"
    >
      <div className="px-[32px] py-[50px] lg:p-[50px]">
        <h4 className="mb-[15px] text-h4 font-[700] text-title">
          {t('res_panel.store_configs.impressum')}
        </h4>
        <div className="impressum-text w-full overflow-hidden text-h6 leading-[150%]">
          <div
            className="prose w-full min-w-full text-base leading-[150%] "
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        </div>
      </div>
    </HeadlessModal>
  );
}
